import { render, staticRenderFns } from "./PricingSlide.vue?vue&type=template&id=369580a0&scoped=true&"
import script from "./PricingSlide.vue?vue&type=script&lang=js&"
export * from "./PricingSlide.vue?vue&type=script&lang=js&"
import style0 from "./PricingSlide.vue?vue&type=style&index=0&id=369580a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369580a0",
  null
  
)

export default component.exports